import { ReadOnlyReviewTable } from '@/components/molecules'

const ReviewProductsTable = ({ 
  displayedProducts = [],
  isLoading = false,
  hasMoreData = false,
  totalProducts = 0,
  onScroll = () => {},
  containerRef = null,
  itemsPerPage = 10,
  className = ''
}) => {
  const hasData = displayedProducts?.length > 0

  if (!hasData) {
    return <></>
  }

  return (
    <div className={`products-table ${className}`} data-testid="products-table-container">
      <div 
        ref={containerRef}
        className="table-scroll-container"
        data-testid="table-scroll-container"
        style={{ 
          maxHeight: '600px', 
          overflowY: 'auto',
          overflowX: 'hidden',
          border: '1px solid #374151',
          borderRadius: '8px',
          backgroundColor: '#1f2937'
        }}
        onScroll={onScroll}
      >
        <ReadOnlyReviewTable 
          products={displayedProducts}
          className=""
        />
        
        {isLoading && (
          <div className="flex justify-center py-4">
            <div className="text-white">Loading more products...</div>
          </div>
        )}
        
        {hasMoreData && !isLoading && (
          <div className="flex justify-center py-4">
            <div className="text-gray-400 text-sm">
              Showing {displayedProducts.length} of {totalProducts} products. Scroll down to load more.
            </div>
          </div>
        )}
        
        {!hasMoreData && displayedProducts.length > itemsPerPage && (
          <div className="flex justify-center py-4">
            <div className="text-gray-400 text-sm">
              All {totalProducts} products loaded.
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default ReviewProductsTable
